import Swiper, {Navigation, Pagination, Scrollbar, EffectFade, Autoplay} from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);

function init() {
	const securitySlider = document.querySelector('.security-slider');
	const homeSlider = document.querySelector('#homeSlider');

	if (securitySlider) {
		// eslint-disable-next-line
		new Swiper('#security-slider', {
			speed: 500,
			direction: 'horizontal',
			loop: true,
			draggable: true,

			navigation: {
				nextEl: securitySlider.querySelector('.swiper-button-next'),
				prevEl: securitySlider.querySelector('.swiper-button-prev'),
			},

			pagination: {
				el: '.swiper-pagination',
				type: 'custom',
				// eslint-disable-next-line
				renderCustom: function (swiper, current, total) {
					// eslint-disable-next-line
					return current + '/' + total;
				// eslint-disable-next-line
				}
			},
		});
	}

	if (homeSlider) {
		new Swiper(homeSlider.querySelector('.swiper'), {
			speed: 500,
			effect: "fade",
			// loop: true,
			autoplay: {
				delay: 8000,
			},

			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
		});
	}
}

export default {
	init,
};

